module.exports = __webpack_public_path__ + "static/media/Image3.93a02fbc.JPG";